import { render, staticRenderFns } from "./AnnotationStyleEditor.vue?vue&type=template&id=7c66d697&scoped=true"
import script from "./AnnotationStyleEditor.vue?vue&type=script&lang=js"
export * from "./AnnotationStyleEditor.vue?vue&type=script&lang=js"
import style0 from "./AnnotationStyleEditor.vue?vue&type=style&index=0&id=7c66d697&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c66d697",
  null
  
)

export default component.exports